/**
 * Friendly label for UI: itemDescription first, else vendor item name (`name` from API / enrich).
 */
export function friendlyItemLabel(item) {
  if (!item) return '';
  const desc = item.itemDescription != null ? String(item.itemDescription).trim() : '';
  if (desc) return desc;
  return item.name != null ? String(item.name).trim() : '';
}

/** Site / batch payloads use `itemName` (vendor) + optional `itemDescription` */
export function friendlyBatchItemLabel(item) {
  if (!item) return '';
  const desc = item.itemDescription != null ? String(item.itemDescription).trim() : '';
  if (desc) return desc;
  return (item.itemName != null ? String(item.itemName) : '').trim();
}

/** Notifications: "Description (Item Name)" or "— (Item Name)" */
export function inventoryNotificationLabel(item) {
  if (!item) return 'Unknown';
  const desc = item.itemDescription != null ? String(item.itemDescription).trim() : '';
  const vendor =
    item.name != null
      ? String(item.name).trim()
      : item.itemName != null
        ? String(item.itemName).trim()
        : '';
  if (desc) return `${desc} (${vendor || 'Unknown'})`;
  return `— (${vendor || 'Unknown'})`;
}

export function compareItemsByFriendlyDisplay(a, b) {
  const fa = friendlyItemLabel(a).toLowerCase();
  const fb = friendlyItemLabel(b).toLowerCase();
  if (fa !== fb) return fa.localeCompare(fb);
  const na = ((a && a.name) || '').toLowerCase();
  const nb = ((b && b.name) || '').toLowerCase();
  return na.localeCompare(nb);
}

export function compareBatchItemsByFriendlyDisplay(a, b) {
  const fa = friendlyBatchItemLabel(a).toLowerCase();
  const fb = friendlyBatchItemLabel(b).toLowerCase();
  if (fa !== fb) return fa.localeCompare(fb);
  const na = ((a && a.itemName) || '').toLowerCase();
  const nb = ((b && b.itemName) || '').toLowerCase();
  return na.localeCompare(nb);
}

/** Search score: description match ranks above name-only match */
export function inventoryTextSearchScore(item, qLower) {
  if (!qLower) return 0;
  const d = ((item.itemDescription || '') + '').toLowerCase();
  const n = ((item.name || '') + '').toLowerCase();
  let score = 0;
  if (d.includes(qLower)) score += 2;
  if (n.includes(qLower)) score += 1;
  return score;
}

/** Same as inventoryNotificationLabel but batch rows use `itemName` for vendor. */
export function batchItemNotificationLabel(item) {
  if (!item) return 'Unknown';
  const desc = item.itemDescription != null ? String(item.itemDescription).trim() : '';
  const vendor = (item.itemName != null ? String(item.itemName) : '').trim();
  if (desc) return `${desc} (${vendor || 'Unknown'})`;
  return `— (${vendor || 'Unknown'})`;
}

export function batchItemTextSearchScore(item, qLower) {
  if (!qLower) return 0;
  const d = ((item.itemDescription || '') + '').toLowerCase();
  const n = ((item.itemName || '') + '').toLowerCase();
  const p = ((item.packSize || '') + '').toLowerCase();
  let score = 0;
  if (d.includes(qLower)) score += 2;
  if (n.includes(qLower)) score += 1;
  if (p.includes(qLower)) score += 1;
  return score;
}
